import '@main';
import '@vendor/rellax/rellax.min.js?8577d775237d8ecef24b9cba';

// Rellax
window.addEventListener('load', () => {
  let bgLineRellax = new Rellax('.rellax');
});

// Banners
const financeBanner = document.querySelector('.c-finance-banner');
const bannerWaves = document.querySelectorAll('.bg-banner-wave');
const bannerLeftLines = document.querySelectorAll('.bg-banner-line--left');
const bannerBottomLines = document.querySelectorAll('.bg-banner-line--bottom');
const bannerRightLine = document.querySelectorAll('.bg-banner-line--right');
const bannerRight1Line = document.querySelectorAll('.bg-banner-line--right1');
const changeColorItem = [bannerWaves, bannerLeftLines, bannerBottomLines, bannerRightLine, bannerRight1Line];

function changeColor(currentIndex) {
  changeColorItem.forEach(el => {
    el.forEach((item, index) => {
      if (index === currentIndex) {
        item.style.opacity = '1';
      } else {
        item.style.opacity = '0';
      }
    });
  });
}

const bannerSwiper1 = new Swiper('.banner-swiper1', {
  slidesPerView: 1,
  spaceBetween : 5,
  autoplay: true,
  delay: 3000,
  on: {
    slideChangeTransitionStart: function () {
      switch (this.activeIndex) {
        case 0:
          financeBanner.style.background = '#FF6666';
          changeColor(0);
          break;
        case 1:
          financeBanner.style.background = '#4C53FF';
          changeColor(1);
          break;
        case 2:
          financeBanner.style.background = '#84A859';
          changeColor(2);
          break;
        case 3:
          financeBanner.style.background = '#FE9B55';
          changeColor(3);
          break;
        case 4:
          financeBanner.style.background = '#68A1BF';
          changeColor(4);
          break;
        default:
          console.log('error');
      }
    },
  },
});

const bannerSwiper2 = new Swiper('.banner-swiper2', {
  slidesPerView: 1,
  spaceBetween : 5,
  autoplay: true,
  delay: 3000,
});

const bannerSwiper3 = new Swiper('.banner-swiper3', {
  slidesPerView: 1,
  spaceBetween : 5,
  autoplay: true,
  delay: 3000,
});

const bannerSwiper4 = new Swiper('.banner-swiper4', {
  slidesPerView: 1,
  spaceBetween : 5,
  autoplay: true,
  delay: 3000,
});

// Video
document.querySelector('.c-interactive-video').playbackRate = 2;

// Flow
const flowSwiper = new Swiper('.flow-swiper', {
  initialSlide: 1,
  slidesPerView: 1.2,
  centeredSlides: true,
  spaceBetween : 10,
  pagination: {
    el: '.swiper-pagination',
    clickable :true,
  },
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  breakpoints: {
    576: {
      slidesPerView: 2,
      spaceBetween: 30
    },
  }
});

document.querySelector('.flow-swiper').addEventListener('mouseover', () => {
  if (window.innerWidth >= 576) {
    document.querySelector('.c-step-prev').classList.add('swiper-nav-show');
    document.querySelector('.c-step-next').classList.add('swiper-nav-show');
  }
})

document.querySelector('.flow-swiper').addEventListener('mouseleave', () => {
  if (window.innerWidth >= 576) {
    document.querySelector('.c-step-prev').classList.remove('swiper-nav-show');
    document.querySelector('.c-step-next').classList.remove('swiper-nav-show');
  }
});

const portfolioSwiper = new Swiper('.portfolio-swiper', {
  initialSlide: 1,
  slidesPerView: 1.2,
  spaceBetween : 10,
  loop: true,
  pagination: {
    el: '.swiper-pagination--portfolio',
    clickable :true,
  },
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  breakpoints: {
    576: {
      centeredSlides: true,
      initialSlide: 2,
      slidesPerView: 2.2,
      spaceBetween: 30
    },
    768: {
      centeredSlides: true,
      initialSlide: 2,
      slidesPerView: 2.5,
      spaceBetween: 30
    },
    1200: {
      centeredSlides: true,
      initialSlide: 2,
      slidesPerView: 4.2,
      spaceBetween: 30
    },
  }
});

// document.querySelector('.portfolio-swiper').addEventListener('mouseover', (e) => {
//   if (window.innerWidth >= 576) {
//     document.querySelector('.c-portfolio-prev').classList.add('swiper-nav-show');
//     document.querySelector('.c-portfolio-next').classList.add('swiper-nav-show');
//   }
// });
//
// document.querySelector('.portfolio-swiper').addEventListener('mouseleave', () => {
//   if (window.innerWidth >= 576) {
//     document.querySelector('.c-portfolio-prev').classList.remove('swiper-nav-show');
//     document.querySelector('.c-portfolio-next').classList.remove('swiper-nav-show');
//   }
// });

const articleSwiper = new Swiper('.article-swiper', {
  slidesPerView: 1.2,
  spaceBetween : 20,
  loop: true,
  pagination: {
    el: '.swiper-pagination--article',
    clickable :true,
  },
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  breakpoints: {
    768: {
      slidesPerView: 2,
      spaceBetween: 24,
    },
    1200: {
      slidesPerView: 3,
      spaceBetween: 24
    },
  }
});

document.querySelector('.article-swiper').addEventListener('mouseover', (e) => {
  if (window.innerWidth >= 576) {
    document.querySelector('.c-article-prev').classList.add('swiper-nav-show');
    document.querySelector('.c-article-next').classList.add('swiper-nav-show');
  }
});

document.querySelector('.article-swiper').addEventListener('mouseleave', () => {
  if (window.innerWidth >= 576) {
    document.querySelector('.c-article-prev').classList.remove('swiper-nav-show');
    document.querySelector('.c-article-next').classList.remove('swiper-nav-show');
  }
});

// Chart

// Only scroll to near chart block then load chart JS
const options = {
  rootMargin: '1000px',
};
const observer = new IntersectionObserver((entries, observer) => {
  entries.forEach((ele) => {
    if (ele.isIntersecting) {
      u.import('@/front/page/finance/sino-efficient.js?8577d775237d8ecef24b9cba');
      observer.unobserve(ele.target);
    }
  });
}, options);
observer.observe(document.querySelector('.l-section--chart'));
